import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLaw: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLaw"><Path d="M12 2.5V20.5M12 20.5H6.5M12 20.5H17.5M2.5 5.5H8.5L10 4.5H14L16 5.5H21.5M2.5 15C4.57693 16.1767 6.42307 16.1767 8.5 15L5.58008 5.75359H5.41992L2.5 15ZM15.5 15C17.5769 16.1767 19.4231 16.1767 21.5 15L18.5801 5.75359H18.4199L15.5 15Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLaw;
